<template>
	<div class="options_list">
		<div class="options_Item" v-for="(item,index) in options" :key="index" @click="handleClickOption(item,index)">
			<div class="left">
				<span v-show="youAnswer.length==0||(youAnswer[0]!=index&&answer[0]!=index)">{{aipchOptions[index]}}</span>
				<i class="el-icon-success"
				v-show="youAnswer.length>0&&answer[0]==index"
				style="font-size: 40px;color:#3964E6;"
				></i>
				<i class="el-icon-error"
				v-show="youAnswer.length>0&&answer[0]!=index&&youAnswer[0]==index"
				style="font-size: 40px;color:#F63F33;"
				></i>
			</div>
			<div class="right">
				{{item.txt}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				aipchOptions:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'],
			}
		},
		props:{
			options:{
				type:Array,
				default:()=>{
					return []
				}
			},
			answer:{
				type:Array,
				default:()=>{
					return []
				},
			},
			quType:{
				type:[Number,String],
				default:''
			},
			isClick:{
				type:Boolean,
				default:true
			},
			youAnswer:{
				type:Array,
				default:()=>{
					return []
				}
			},
		},
		methods:{
			handleClickOption(item,i){
				console.log(this.isClick)
				if(this.isClick){
					var obj={
						myAnswer:[i],
						isFlag:this.answer.includes(i),
						myOpation:item,
						isClick:false
					}
					this.$emit('setAnswer',obj)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.options_list{
		margin-top: 20px;
	}
	.options_Item{
		display: flex;
		margin-bottom: 20px;
			cursor: pointer;
		.left{
			width: 40px;
			height: 40px;
			color: #333333;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0px 1px 7px 0px rgb(0 0 0 / 10%);
			box-sizing: border-box;
			line-height: 1;
			margin-right: 33px;
			overflow: hidden;
			font-size: 20px;
		
		}
		.right{
			margin-top: 10px;
			flex: 1;
			font-size: 16px;
		}
	}
</style>
